<div class="client-list-modal">
  <!-- Header -->
  <div class="client-list-modal__rectangle"></div>

  <div class="d-flex align-items-center justify-content-end mb-2 pr-4">
    <button type="button" class="client-list-modal__close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">
        <img src="../../../../assets/img/app/little-icons/cancel.svg" alt="cancel" />
      </span>
    </button>
  </div>

  <!-- Title -->
  <div class="client-list-modal__header justify-content-start mb-4">
    <h4 class="client-list-modal__title">Listado de Clientes</h4>
  </div>

  <!-- Body -->
  <div class="client-list-modal__body">
    <!-- Filtros -->
    <div class="client-list-modal__filters mb-4">
      <h5 class="client-list-modal__subtitle mb-4">Buscar cliente</h5>

      <form [formGroup]="filterForm" (ngSubmit)="onFilterChange()" novalidate autocomplete="off">
        <!-- Filter Fields -->
        <div class="row mb-3" style="padding: 0px 15px;">
          <label class="col-4" style="padding: 0px 3px;" for="clientFilterFirstName">
            <div class="client-list-modal__label">Nombre</div>
            <input
              id="clientFilterFirstName"
              class="client-list-modal__select"
              [class.client-list-modal__select--invalid]="hasError('firstName')"
              type="text"
              formControlName="firstName"
              placeholder="Ej: Juan"
              maxlength="50"
              [attr.aria-invalid]="hasError('firstName')"
              aria-describedby="clientFilterFirstNameError"
            />
            <small id="clientFilterFirstNameError" class="client-list-modal__error" *ngIf="hasError('firstName', 'pattern')">
              Solo letras, espacios, apóstrofos y guiones
            </small>
          </label>
          <label class="col-4" style="padding: 0px 3px;" for="clientFilterLastName">
            <div class="client-list-modal__label">Apellido</div>
            <input
              id="clientFilterLastName"
              class="client-list-modal__select"
              [class.client-list-modal__select--invalid]="hasError('lastName')"
              type="text"
              formControlName="lastName"
              placeholder="Ej: Pérez"
              maxlength="50"
              [attr.aria-invalid]="hasError('lastName')"
              aria-describedby="clientFilterLastNameError"
            />
            <small id="clientFilterLastNameError" class="client-list-modal__error" *ngIf="hasError('lastName', 'pattern')">
              Solo letras, espacios, apóstrofos y guiones
            </small>
          </label>
          <label class="col-4" style="padding: 0px 3px;" for="clientFilterEmail">
            <div class="client-list-modal__label">Email</div>
            <input
              id="clientFilterEmail"
              class="client-list-modal__select"
              [class.client-list-modal__select--invalid]="hasError('email')"
              type="text"
              inputmode="email"
              formControlName="email"
              placeholder="Ej: juan@mail.com"
              maxlength="100"
              [attr.aria-invalid]="hasError('email')"
              aria-describedby="clientFilterEmailError"
            />
            <small id="clientFilterEmailError" class="client-list-modal__error" *ngIf="hasError('email', 'pattern')">
              Contiene caracteres no válidos para un email
            </small>
          </label>
        </div>

        <!-- Filter Buttons -->
        <div class="row">
          <div class="col-8"></div>
          <div class="col-4">
            <div class="d-flex align-items-center" style="gap: 10px;">
              <button type="button" class="btn btn-cancel w-100 py-1 px-2" (click)="clearFilters()">Borrar</button>
              <button type="submit" class="btn btn-confirm w-100 py-1 px-2" [disabled]="loading || filterForm.invalid">
                {{ loading ? 'Buscando...' : 'Buscar' }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

<!-- Tabla -->
    <div class="client-list-modal__table-wrapper">
      <table class="client-list-modal__table">
        <thead class="client-list-modal__table-head">
          <tr class="client-list-modal__table-row">
            <th class="client-list-modal__table-cell client-list-modal__table-cell--header">Nombre</th>
            <th class="client-list-modal__table-cell client-list-modal__table-cell--header">Apellido</th>
            <th class="client-list-modal__table-cell client-list-modal__table-cell--header">Email</th>
            <th class="client-list-modal__table-cell client-list-modal__table-cell--header text-center">Seleccionar</th>
          </tr>
        </thead>
        <tbody class="client-list-modal__table-body">
          <tr class="client-list-modal__table-row" *ngFor="let client of clients">
            <td class="client-list-modal__table-cell">{{ client.first_name || '-' }}</td>
            <td class="client-list-modal__table-cell">{{ client.last_name || '-' }}</td>
            <td class="client-list-modal__table-cell">{{ client.email || '-'}}</td>
            <td class="client-list-modal__table-cell text-center">
              <input
                class="client-list-modal__table-cell-checkbox"
                type="checkbox"
                [checked]="selectedClientEmail === client.email"
                (change)="selectClient(client)"
              />
            </td>
          </tr>
          <tr class="client-list-modal__table-row client-list-modal__table-row--empty" *ngIf="clients.length === 0">
            <td colspan="4" class="client-list-modal__table-cell client-list-modal__table-cell--empty">No se encontraron clientes</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Paginación -->
    <div class="client-list-modal__pagination">
      <span class="client-list-modal__pagination-info">
        {{ startItem }} - {{ endItem }} de {{ totalItems }}
      </span>

      <div class="client-list-modal__pagination-controls">
        <button
          class="client-list-modal__pagination-btn"
          (click)="previousPage()"
          [disabled]="currentPage === 1"
        >
          &lt;
        </button>
        <button
          class="client-list-modal__pagination-btn"
          (click)="nextPage()"
          [disabled]="currentPage >= lastPage"
        >
          &gt;
        </button>
      </div>
    </div>
  </div>
</div>
